import { Search } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useServicesUIStore } from "../../store/use-services-ui-store";

interface ServicesSearchProps {
  variant: "mobile" | "desktop";
  autoFocus?: boolean;
}

export function ServicesSearch({ variant, autoFocus = false }: ServicesSearchProps) {
  const { t } = useTranslation("services");
  const { searchTerm, setSearchTerm } = useServicesUIStore();

  if (variant === "mobile") {
    return (
      <div className="flex items-center gap-3">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground w-4 h-4" />
          <Input
            placeholder={t("search.placeholder")}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="pl-10"
            autoFocus={autoFocus}
          />
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setSearchTerm("")}
          className="text-muted-foreground hover:text-foreground"
        >
          {t("search.clear")}
        </Button>
      </div>
    );
  }

  // Desktop variant
  return (
    <div className="relative">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground w-4 h-4" />
      <Input
        placeholder={t("search.placeholder")}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="pl-10 w-full sm:max-w-sm shadow-none bg-background"
      />
    </div>
  );
}
